import { render } from "./Multiplication.vue?vue&type=template&id=4ad7c5f1&scoped=true"
import script from "./Multiplication.vue?vue&type=script&lang=js"
export * from "./Multiplication.vue?vue&type=script&lang=js"

import "./Multiplication.vue?vue&type=style&index=0&id=4ad7c5f1&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ad7c5f1"]])

export default __exports__